module.exports = __webpack_public_path__ + "img/intro-hand.2360a635.png";